// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3rNSQ","rootSmall":"AddTileButton_rootSmall__3Rigb"};